// extracted by mini-css-extract-plugin
export default {"errorpage":"errorpage--1KCRg","errorpage__img":"errorpage__img--2Ko4r","errorpage__title":"errorpage__title--3w4uV"};
    if(module.hot) {
      // 1747648130377
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  